import React, { useRef } from 'react';
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { FormInputContainerStyled, FormInputLabelContainerStyled, ValidationLabelStyled } from './styles';
import { setFieldLabel } from './utilis/setFieldLabel';

const TextAreaFieldSync = ({ field, value, isLocked, setNewValue, renderData }) => {
  const textboxRef = useRef(null);
  const { t } = useTranslation();

  const onChange = (args) => {
    setNewValue(args.value);
  };

  const onCreate = () => {
    try {
      textboxRef.current.respectiveElement.style.height = field.height + 'px';
    } catch (error) {
      console.log('error :>> ', error);
    }
  };

  return (
    <FormInputContainerStyled hidden={+field.hidden}>
      <FormInputLabelContainerStyled>
        {setFieldLabel(field, renderData, value, t)}
      </FormInputLabelContainerStyled>
      <ValidationLabelStyled id={`validation-label-${field.attribute.key}`}></ValidationLabelStyled>
      <TextBoxComponent
        multiline={true}
        value={value === null ? '' : value}
        ref={textboxRef}
        change={onChange}
        created={onCreate}
        enabled={!isLocked}
        name={field.name}
        data-msg-containerid={`error-${field.attribute.key}`}
      />
      <div id={`error-${field.attribute.key}`} />
    </FormInputContainerStyled>
  );
};

TextAreaFieldSync.propTypes = {
  field: PropTypes.object,
  setNewValue: PropTypes.func,
  value: PropTypes.any,
  isLocked: PropTypes.bool,
  hiddenClass: PropTypes.any,
  renderData: PropTypes.object
};

export default TextAreaFieldSync;
